// extracted by mini-css-extract-plugin
export var arrow = "AdjacentPostButton-module--arrow--2c5cc";
export var next = "AdjacentPostButton-module--next--c5298";
export var prev = "AdjacentPostButton-module--prev--1581f";
export var root = "AdjacentPostButton-module--root--41392";
export var text = "AdjacentPostButton-module--text--ac61d";